import {ADICIONAR_FILTRO_CENTRO_CUSTO } from '../types';

export default function adicionarFiltroCentroCusto (filtro) {
  return {
    type: ADICIONAR_FILTRO_CENTRO_CUSTO,
    payload: filtro
  }
}
